import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../_actions';
import './HomePage.css';
import { Footer } from '../footer/Footer';
import { createBrowserHistory } from 'history';
import axios from 'axios';
import { withRouter } from "react-router-dom";

class PasswordResetPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            temppass: '',
            password: '',
            confirmpass: '',
            submitted: false,
            tempError: false,
            mismatchError: false,
            loginError: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.props.getUsers();
    }

    handleDeleteUser(id) {
        return (e) => this.props.deleteUser(id);
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        const history = createBrowserHistory();

        this.setState({ submitted: true, loginError: false });
        const { temppass, password, confirmpass  } = this.state;
        const userObj = JSON.parse(localStorage.getItem('user'));
        if (temppass && password && confirmpass) {
            const postBody = {temppass: this.state.temppass, password: this.state.password, confirmpass: this.state.confirmpass, token: userObj.token}
            if (password != confirmpass) {
                this.setState({ mismatchError: true, tempError: false, submitted: false});
            } else {
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/passwordchange.php`, { postBody })
                .then(res => {
                    console.log(res.data);
                    if(res.data.notFound) {
                        this.setState({ submitted: false, tempError: true, mismatchError: false });
                    } else {
                        this.props.history.push('/');
                    }
                });
            }
        }
    }

    render() {
        //const { user, users } = this.props;
        const { loggingIn } = this.props;
        const { temppass, password, confirmpass, submitted } = this.state;
        return (
                <Fragment>
                    <div className="solar">
                    <br/><br/>
                    <div className="container">
                        
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3 col-sm-12">
                                <div className="card rounded shadow-lg solarcard border-0">
                                { this.state.tempError ? <div className="alert alert-danger">Temporary Password is invalid</div> : null}
                                { this.state.mismatchError ? <div className="alert alert-danger">Password's don't match</div> : null}
                                    <div className="card-header">
                                        <br />
                                        <h1 className="text-center font-weight-bold">Change Password</h1>
                                    </div>
                                    <div className="card-body">
                                        <form name="form" onSubmit={this.handleSubmit}>
                                            <div className={'form-group' + (submitted && !temppass ? ' has-error' : '')}>
                                                <label htmlFor="email" className="sr-only">Temporary Password:</label>
                                                <input type="text" className="form-control" name="temppass" value={temppass} onChange={this.handleChange} placeholder="Temporary Password" />
                                                {submitted && !temppass &&
                                                <div className="help-block">Temporary Password is required</div>
                                                }
                                            </div>
                                            <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                                <label htmlFor="pwd" className="sr-only">Password:</label>
                                                <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} placeholder="Password" />
                                                {submitted && !password &&
                                                <div className="help-block">Password is required</div>
                                                }
                                            </div>
                                            <div className={'form-group' + (submitted && !confirmpass ? ' has-error' : '')}>
                                                <label htmlFor="pwd" className="sr-only">Confirm Password:</label>
                                                <input type="password" className="form-control" name="confirmpass" value={confirmpass} onChange={this.handleChange} placeholder="Confirm Password" />
                                                {submitted && !confirmpass &&
                                                <div className="help-block">Confirm Password is required</div>
                                                }
                                            </div>
                                            <div className="form-group">
                                                <p className="text-center">
                                                    <button className="btn btn-primary" onClick={this.handleSubmit}>Change Password</button></p>
                                                {loggingIn &&
                                                <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                                }
                                            </div>

                                            <br />
                                        </form>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <Footer></Footer>
                </Fragment>
                

        );
    }
}

function mapState(state) {
    const { users, authentication } = state;
    const { user } = authentication;
    return { user, users };
}

const actionCreators = {
    getUsers: userActions.getAll,
    deleteUser: userActions.delete
}

const connectedHomePage = connect(mapState, actionCreators)(PasswordResetPage);
export { connectedHomePage as PasswordResetPage };